import React, {Component} from 'react';
// rest client
import {eapiClient, aemHostClient} from '../../../../restClient';
// utils
import {Translations} from '../../../../utils';
// style
import './styles.css';

export default class AddGroupSearchBox extends Component {
  constructor(props){
    super(props);
    this.state ={
      options: [],
      showOptions: false,
      showCreateEntity: false,
      selectedOptionValue: '',
      selectedOption: ''
    }
  }

    componentWillMount(){
        aemHostClient("/aemData/formData/json_edit-entity")
        .then(({data}) => {
          this.setState({formJson: data});
        });
    }

  filterList = (event) => {
    var query = event.target.value;
    this.setState({
      selectedOptionValue:query
    });
    if(query.length > 2){
      this.setState({showCreateEntity: true});
      let url = '/usergroup/groupName?groupName=' + query;
      eapiClient(url, {noBlocking: true})
      .then(({data}) => {
        if(data.responseStatus.serviceErrorCode !== 404 && Array.isArray(data.responseData)){
          this.setState({ options: data.responseData, showOptions: true });
        }else {
          this.hideOptions();
        }
      });
    }else {
      this.setState({showCreateEntity: false}, () => {
        this.hideOptions();
      });
    }
  }

  setSelectedOptions = (event, groupEntity) => {
    this.setState({
      selectedOption: groupEntity
    });
    this.resetSearch();
    this.hideOptions();
    this.props.setSelectedOptions(groupEntity);
  }

  resetSearch = () => {
    this.setState({selectedOptionValue: '', options: [], showCreateEntity: false});
  }

  showOptions = () => {
    this.setState({showOptions: true});
  }

  hideOptions = () => {
    this.setState({showOptions: false});
  }
  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {

    const options = (
      <List
        role="option"
        tabIndex="0"
        items={this.state.options}
        _setSelectedOptions={(event, entity) => this.setSelectedOptions(event, entity)}
        aria-selected="true"
      />
    );

    return (
      <div className="customersearchcont">
      <div className="filterdata">
      <fieldset className="form-group searchListform">
      <label className="customerlbl gdocs-mbottom-10">{this.translations(this.props.pageJson.type_ahead_addGroup.title)}</label>
      <input
      type="text"
      tabIndex="0"
      maxLength={this.props.maxLength}
      id="searchText"
      onFocus={this.showOptions}
      onChange={this.filterList}
      value={this.state.selectedOptionValue}
      className="form-control form-control-lg"
      />
      <span className="icon icon-search serachicon"></span>
      </fieldset>
      </div>
      <div id="searchId" className="searchList" role="dropdown">
      {this.state.showOptions ? options : ''}
      </div>
      </div>
    );
  }
}

const List = (props) => (
  <div className="listContent" id="setList">
  {
    props.items.map((item, index) => (
      <div className="listdata" key={index}>
      <div className="searchListdata"
      data-category={item.resolveError}
      tabIndex="0"
      onClick={(event) => props._setSelectedOptions(event, item)}
      >
      {item.group + " - " + (item.countryOfFormation !== "" ? item.group : 'Not Available')}
      </div>
      <div className="divide"></div>
      </div>
    ))
  }
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/AddGroupSearchBox/index.js